export * from './lib/active-locale.token';
